import './App.css';
import Search from './Components/Search/Search';

function App() {
  return (
     <Search />
  );
}

export default App;
